import React from "react";
import { AppProvider } from "./src/context/AppContext";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <AppProvider>{element}</AppProvider>;
};
